<div class="container text-center">
  <div class="mt-3 mb-4">
    <svg
      class="icon-size-96-96"
      role="img"
      title="Profile"
    >
      <use xlink:href="../../../../assets/icons/svg-sprite.svg#icon-profile" />
    </svg>
  </div>

  <div>
    <h2 class="h4 text-primary mb-0 fw-bold">{{ userName }}</h2>
  </div>
</div>
